export default __webpack_public_path__ + "static/media/tn-ventas-02-EN.08eadc47.jpg";